import React from 'react';
import {Field, ErrorMessage} from 'formik';
import TextError from './TextError';

function Select(props){
    const {label, name, options, disabled, ...rest} = props
    var BackColor = '';
    if(disabled === true) {
      BackColor = '#DCDCDC';
    }
    else {
      BackColor = 'white';
    }

    return(
        <div>
            <label htmlFor={name} style={{display:'block', width: '100%'}}>{label}</label>
            <Field 
                as='select' 
                id={name} 
                name={name} 
                disabled={disabled}
                style={{display:'block', width: '100%', height:'30px', borderRadius:'3px', border:'1px solid #777', backgroundColor:BackColor}} 
                {...rest} 
            >
               {/*  {options.map(option => {
                    return (
                        <option key={option.value} value={option.value}>
                            {option.key}
                        </option>
                    )
                })} */}
                <option></option>
                {options}
            </Field>
            <ErrorMessage name={name} component={TextError} />
        </div>
    )
}

export default Select
